import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import CheckpointEditor from "./CheckpointEditor";

class Checkpoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditor: false,
      editId: 0,
      fetchingItem: false,
    };

    this.handleChangeId = this.handleChangeId.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.showEditor = this.showEditor.bind(this);
    this.hideEditor = this.hideEditor.bind(this);
  }

  componentDidMount() {
    this.setState({ fetchingItem: true });
    this.props.fetchItems(() => this.setState({ fetchingItem: false }));
  }

  showEditor(id) {
    const newState = {
      showEditor: true,
      editId: id,
      fetchingItem: false,
    };

    if (id === 0) {
      this.setState(newState);
    } else {
      newState.fetchingItem = true;
      this.setState(newState);

      this.props.fetchItem(
        id,
        () => this.setState({ fetchingItem: false }),
        () => this.setState({ fetchingItem: false, showEditor: false })
      );
    }
  }

  hideEditor() {
    this.setState({ ...this.state, showEditor: false });
  }

  handleChangeId(e) {
    this.props.changeSearchId(e.target.value);
  }

  handleChange(e) {
    this.props.changeSearchText(e.target.value);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.searchItems(this.props.category_id, this.props.text);
  }

  handleReset(e) {
    e.preventDefault();
    this.props.changeSearchId("");
    this.props.changeSearchText("");
    this.props.searchItems("", "");
  }

  handleDelete(id, name) {
    this.props.deleteItem(id, name);
  }

  handleSave(data, cancelHandler, errorHandler) {
    if (data.checkpoint_id === 0) {
      this.props.createItem(data, this.hideEditor, cancelHandler);
    } else {
      this.props.updateItem(data, this.hideEditor, cancelHandler, errorHandler);
    }
  }

  render() {
    const { category_id, text, items, current, fetching, isError, t, categories } = this.props;

    return (
      <div>
        <div className="contents">
          <div className="inner">
            <h1 className="page-ttl">
              {t("master_manage")}：{t("checkpoint")}
              <span
                data-test-id="master-checkpoint-button-add"
                className="toggle icon-add_circle"
                onClick={() => this.showEditor(0)}
              ></span>
            </h1>
            <form className="search-box w-950" onSubmit={this.handleSubmit}>
              <div className="form-row mb-0">
                <div className="form-group w-340">
                  <span className="form-label">{t("category_name")}</span>
                  <select
                    className="form-control w-260"
                    value={category_id}
                    onChange={this.handleChangeId}
                    data-test-id="master-checkpoint-search-category"
                  >
                    <option key={0} value={0}>
                      -----
                    </option>
                    {categories.map((category) => (
                      <option key={category.category_id} value={category.category_id}>
                        {category.category_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group w-400">
                  <span className="form-label">{t("checkpoint_name")}</span>
                  <input
                    data-test-id="master-checkpoint-search-name"
                    type="text"
                    name="text"
                    value={text}
                    onChange={this.handleChange}
                    className="form-control w-270"
                  />
                </div>
                <div className="form-group btn-area pull-right">
                  <button
                    data-test-id="master-checkpoint-search-button-search"
                    type="submit"
                    className="btn btn-blue"
                    disabled={fetching}
                  >
                    {t("search")}
                  </button>
                </div>
              </div>
            </form>
            <div className={`tbl-category ${fetching ? "loading loading--list" : ""} mb-20`}>
              {this.props.items.length === 0 ? (
                !fetching && <p className="empty-message">{t("no_data")}</p>
              ) : (
                <table className="tbl-basic tbl-data">
                  <thead>
                    <tr>
                      <th>{t("category_name")}</th>
                      <th>{t("checkpoint_name")}</th>
                      <th width="120">{t("display_order")}</th>
                      <th width="80">{t("edit")}</th>
                      <th width="80">{t("remove")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td data-test-id={`master-checkpoint-${index + 1}-category`}>{item.category_name}</td>
                          <td data-test-id={`master-checkpoint-${index + 1}-name`}>{item.checkpoint_name}</td>
                          <td data-test-id={`master-checkpoint-${index + 1}-sort`} className="txt-center">
                            {item.sort}
                          </td>
                          <td className="txt-center">
                            <a
                              onClick={() => this.showEditor(item.checkpoint_id)}
                              data-test-id={`master-checkpoint-${index + 1}-link-edit`}
                            >
                              {t("edit")}
                            </a>
                          </td>
                          <td className="txt-center">
                            <a
                              onClick={() => this.handleDelete(item.checkpoint_id, item.checkpoint_name)}
                              data-test-id={`master-checkpoint-${index + 1}-link-delete`}
                            >
                              {t("remove")}
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
        {this.state.showEditor && (
          <CheckpointEditor
            data={this.state.editId === 0 ? null : current}
            closeHandler={this.hideEditor}
            saveHandler={this.handleSave}
            items={items}
            fetching={this.state.fetchingItem}
            categories={categories}
            setUnloadAlert={this.props.setUnloadAlert}
            clearUnloadAlert={this.props.clearUnloadAlert}
          />
        )}
      </div>
    );
  }
}

Checkpoint.defaultProps = {
  masterItems: [],
  category_id: "",
  text: "",
  items: [],
  current: null,
};

Checkpoint.propTypes = {
  masterItems: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  current: PropTypes.object,
  fetching: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  fetchItems: PropTypes.func.isRequired,
  changeSearchId: PropTypes.func.isRequired,
  changeSearchText: PropTypes.func.isRequired,
  searchItems: PropTypes.func.isRequired,
  fetchItem: PropTypes.func.isRequired,
  createItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  setUnloadAlert: PropTypes.func.isRequired,
  clearUnloadAlert: PropTypes.func.isRequired,
};

export default withTranslation()(Checkpoint);
